import {DEFAULT_COLOR_ID} from '../../workflowStatus/constants'

export const NEW_STATUS_ID = -1
export const NEW_STATUS_COLOR_ID = DEFAULT_COLOR_ID

export const ValidationErrors = {
    DUPLICATE_NAME_ERROR: 'DUPLICATE_NAME_ERROR',
    EMPTY_NAME_ERROR: 'EMPTY_NAME_ERROR',
    STATUS_DELETED: 'STATUS_DELETED',
    STATUS_IN_USE: 'STATUS_IN_USE',
    STATUS_IS_LAST: 'STATUS_IS_LAST',
}

export const apiExceptions = {
    FEATURE_DISABLED_EXCEPTION: 'com.actimind.actitime.services.FeatureIsDisabledException',
    DUPLICATE_NAME_EXCEPTION: 'com.actimind.actitime.services.WorkflowStatusNameDuplicateException',
    STATUS_DELETED_EXCEPTION: 'com.actimind.actitime.services.WorkflowStatusConcurrentlyDeletedException',
    STATUS_IN_USE_EXCEPTION: 'com.actimind.actitime.services.WorkflowStatusIsInUseException',
    STATUS_IS_LAST_EXCEPTION: 'com.actimind.actitime.services.WorkflowStatusIsLastException'
}

export const enabledStatus = {
    ENABLED: 'ENABLED',
    IN_USE: 'IN_USE',
    LAST: 'LAST'
}

export const ENABLED_STATUS_MESSAGE_KEY_BY_STATUS = {
    [enabledStatus.IN_USE]: 'workflow_settings.errors.status_in_use',
    [enabledStatus.LAST]: 'workflow_settings.errors.status_is_last'
}


// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/constants.js